import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import {
  AntiCounterfeitStateModel,
  AntiCounterfeitOrderStatus,
  AntiCounterfeitOrder,
} from './anti-counterfeit.model';
import { Header } from '../general-store/general.model';
import {
  GetAntiCounterfeitOrderList,
  GetAntiCounterfeitOrder,
  CreateAntiCounterfeitOrder,
  UpdateAntiCounterfeitOrder,
  DeleteAntiCounterfeitOrder,
  ResetAntiCounterfeitHeaders,
} from './anti-counterfeit.actions';
import { Organization } from '../organizations-store/organizations.model';

// Hardcoded sample data
const SAMPLE_ANTI_COUNTERFEIT_ORDERS = [
  {
    id: 1,
    qrOrderId: 1,
    productId: 1,
    organizationId: 1,
    createdById: 1,
    quantity: 40000,
    printerVendor: 'SecurePrint Solutions',
    status: AntiCounterfeitOrderStatus.PENDING,
    orderedDate: '2025-08-25T00:00:00.000Z',
    receivedDate: undefined,
    createdAt: '2025-08-25T10:15:16.000Z',
    updatedAt: '2025-08-25T10:15:16.000Z',
    productName: 'XOPE Biome Medicine 500mg', // Add flat field for table display
    product: {
      id: 1,
      createdById: 1,
      organizationId: 1,
      productName: 'XOPE Biome Medicine 500mg',
      brandName: 'XOPE',
      productDescription: 'Biome Medicine 500mg',
      gtin: '1234567890123',
      logo: '',
      fdaClassified: false,
      gs1Compliant: false,
      createdAt: '2025-08-25T10:15:16.000Z',
      updatedAt: '2025-08-25T10:15:16.000Z',
      deletedAt: undefined,
      productCtes: [],
      productQrSettings: [],
      productDesignTemplates: [],
      links: {},
      productImages: [],
      greenDuration: 30,
      yellowDuration: 7,
      redDuration: 3,
    },
    organization: {
      id: 1,
      name: 'Telcar Cocoa',
      type: 'ORGANIZATION',
      gln: '1234567890123',
      email: 'info@telcar.com',
      phone: '+1234567890',
      countryId: 1,
      cityId: 1,
      businessAddress: '123 Main St, Accra, Ghana',
      logo: '',
      contactPerson: 'John Doe',
      contactPersonDesignation: 'MANAGER',
      createdAt: '2025-08-25T10:15:16.000Z',
      updatedAt: '2025-08-25T10:15:16.000Z',
      deletedAt: undefined,
      hasSetupFeePaid: true,
      hasUsedTrial: false,
    },
    qrOrder: {
      id: 1,
      batchSize: 40000,
      packagingUnit: 'bag',
    },
  },
  {
    id: 2,
    qrOrderId: 2,
    productId: 2,
    organizationId: 1,
    createdById: 1,
    quantity: 25000,
    printerVendor: 'AntiFraud Printers',
    status: AntiCounterfeitOrderStatus.COMPLETE,
    orderedDate: '2025-08-20T00:00:00.000Z',
    receivedDate: '2025-08-22T00:00:00.000Z',
    createdAt: '2025-08-20T09:30:00.000Z',
    updatedAt: '2025-08-22T14:20:00.000Z',
    productName: 'Organic Cocoa Beans Premium', // Add flat field for table display
    product: {
      id: 2,
      createdById: 1,
      organizationId: 1,
      productName: 'Organic Cocoa Beans Premium',
      brandName: 'Telcar',
      productDescription: 'Premium Organic Cocoa Beans',
      gtin: '9876543210987',
      logo: '',
      fdaClassified: false,
      gs1Compliant: false,
      createdAt: '2025-08-20T09:30:00.000Z',
      updatedAt: '2025-08-20T09:30:00.000Z',
      deletedAt: undefined,
      productCtes: [],
      productQrSettings: [],
      productDesignTemplates: [],
      links: {},
      productImages: [],
      greenDuration: 30,
      yellowDuration: 7,
      redDuration: 3,
    },
    organization: {
      id: 1,
      name: 'Telcar Cocoa',
      type: 'ORGANIZATION',
      gln: '1234567890123',
      email: 'info@telcar.com',
      phone: '+1234567890',
      countryId: 1,
      cityId: 1,
      businessAddress: '123 Main St, Accra, Ghana',
      logo: '',
      contactPerson: 'John Doe',
      contactPersonDesignation: 'MANAGER',
      createdAt: '2025-08-25T10:15:16.000Z',
      updatedAt: '2025-08-25T10:15:16.000Z',
      deletedAt: undefined,
      hasSetupFeePaid: true,
      hasUsedTrial: false,
    },
    qrOrder: {
      id: 2,
      batchSize: 25000,
      packagingUnit: 'bag',
    },
  },
  {
    id: 3,
    qrOrderId: 3,
    productId: 3,
    organizationId: 1,
    createdById: 1,
    quantity: 15000,
    printerVendor: 'SecurePrint Solutions',
    status: AntiCounterfeitOrderStatus.PROCESSING,
    orderedDate: '2025-08-28T00:00:00.000Z',
    receivedDate: undefined,
    createdAt: '2025-08-28T11:45:00.000Z',
    updatedAt: '2025-08-28T11:45:00.000Z',
    productName: 'Dark Chocolate 70%', // Add flat field for table display
    product: {
      id: 3,
      createdById: 1,
      organizationId: 1,
      productName: 'Dark Chocolate 70%',
      brandName: 'Telcar',
      productDescription: 'Premium Dark Chocolate 70%',
      gtin: '4567891234567',
      logo: '',
      fdaClassified: false,
      gs1Compliant: false,
      createdAt: '2025-08-28T11:45:00.000Z',
      updatedAt: '2025-08-28T11:45:00.000Z',
      deletedAt: undefined,
      productCtes: [],
      productQrSettings: [],
      productDesignTemplates: [],
      links: {},
      productImages: [],
      greenDuration: 30,
      yellowDuration: 7,
      redDuration: 3,
    },
    organization: {
      id: 1,
      name: 'Telcar Cocoa',
      type: 'ORGANIZATION',
      gln: '1234567890123',
      email: 'info@telcar.com',
      phone: '+1234567890',
      countryId: 1,
      cityId: 1,
      businessAddress: '123 Main St, Accra, Ghana',
      logo: '',
      contactPerson: 'John Doe',
      contactPersonDesignation: 'MANAGER',
      createdAt: '2025-08-25T10:15:16.000Z',
      updatedAt: '2025-08-25T10:15:16.000Z',
      deletedAt: undefined,
      hasSetupFeePaid: true,
      hasUsedTrial: false,
    },
    qrOrder: {
      id: 3,
      batchSize: 15000,
      packagingUnit: 'box',
    },
  },
];

const SAMPLE_HEADERS: Header[] = [
  {
    label: 'Product Name',
    key: 'productName',
    isVisibleHeader: true,
    sortable: true,
    filterable: true,
    filterValues: [],
  },
  {
    label: 'Quantity',
    key: 'quantity',
    isVisibleHeader: true,
    sortable: true,
    filterable: false,
    filterValues: [],
  },
  {
    label: 'Printer Vendor',
    key: 'printerVendor',
    isVisibleHeader: true,
    sortable: true,
    filterable: true,
    filterValues: [],
  },
  {
    label: 'Status',
    key: 'status',
    isVisibleHeader: true,
    sortable: true,
    filterable: true,
    filterValues: [],
  },
  {
    label: 'Ordered Date',
    key: 'orderedDate',
    isVisibleHeader: true,
    sortable: true,
    filterable: false,
    filterValues: [],
  },
  {
    label: 'Received Date',
    key: 'receivedDate',
    isVisibleHeader: true,
    sortable: true,
    filterable: false,
    filterValues: [],
  },
  {
    label: 'Created At',
    key: 'createdAt',
    isVisibleHeader: true,
    sortable: true,
    filterable: false,
    filterValues: [],
  },
  {
    label: 'Actions',
    key: 'actions',
    isVisibleHeader: true,
    sortable: false,
    filterable: false,
    filterValues: [],
  },
];

@State<AntiCounterfeitStateModel>({
  name: 'AntiCounterfeit',
  defaults: {
    isProcessing: false,
    isListRefreshing: false,
    antiCounterfeitOrders: SAMPLE_ANTI_COUNTERFEIT_ORDERS as unknown as AntiCounterfeitOrder[],
    antiCounterfeitOrder: null,
    pagination: {
      currentPage: 1,
      itemsPerPage: 10,
      totalItems: SAMPLE_ANTI_COUNTERFEIT_ORDERS.length,
      totalPages: Math.ceil(SAMPLE_ANTI_COUNTERFEIT_ORDERS.length / 10),
    },
    headers: SAMPLE_HEADERS,
  },
})
@Injectable({
  providedIn: 'root',
})
export class AntiCounterfeitState {
  @Selector()
  static getAntiCounterfeitOrders(state: AntiCounterfeitStateModel) {
    return state.antiCounterfeitOrders;
  }

  @Selector()
  static getAntiCounterfeitOrder(state: AntiCounterfeitStateModel) {
    return state.antiCounterfeitOrder;
  }

  @Selector()
  static isProcessing(state: AntiCounterfeitStateModel) {
    return state.isProcessing;
  }

  @Selector()
  static isListRefreshing(state: AntiCounterfeitStateModel) {
    return state.isListRefreshing;
  }

  @Selector()
  static getPaginationData(state: AntiCounterfeitStateModel) {
    return state.pagination;
  }

  @Selector()
  static getHeaders(state: AntiCounterfeitStateModel) {
    return state.headers;
  }

  @Action(GetAntiCounterfeitOrderList)
  getAntiCounterfeitOrderList(
    { patchState }: StateContext<AntiCounterfeitStateModel>,
    action: GetAntiCounterfeitOrderList,
  ) {
    patchState({ isProcessing: true });

    // Simulate API delay
    setTimeout(() => {
      const { first, rows } = action.payload;
      const startIndex = first;
      const endIndex = startIndex + rows;
      const paginatedOrders = SAMPLE_ANTI_COUNTERFEIT_ORDERS.slice(startIndex, endIndex);

      patchState({
        antiCounterfeitOrders: paginatedOrders as unknown as AntiCounterfeitOrder[],
        pagination: {
          currentPage: Math.floor(startIndex / rows) + 1,
          itemsPerPage: rows,
          totalItems: SAMPLE_ANTI_COUNTERFEIT_ORDERS.length,
          totalPages: Math.ceil(SAMPLE_ANTI_COUNTERFEIT_ORDERS.length / rows),
        },
        headers: SAMPLE_HEADERS,
        isProcessing: false,
      });
    }, 500);
  }

  @Action(GetAntiCounterfeitOrder)
  getAntiCounterfeitOrder(
    { patchState }: StateContext<AntiCounterfeitStateModel>,
    action: GetAntiCounterfeitOrder,
  ) {
    patchState({ isProcessing: true });

    // Simulate API delay
    setTimeout(() => {
      const order = SAMPLE_ANTI_COUNTERFEIT_ORDERS.find((o) => o.id === action.payload);

      patchState({
        antiCounterfeitOrder:
          order && order.organization
            ? ({
                ...order,
                organization: {
                  ...order.organization,
                  isSubscriptionBypassed:
                    (order.organization as Organization).isSubscriptionBypassed ?? false,
                  gtag: (order.organization as Organization).gtag ?? null,
                  subdomain: (order.organization as Organization).subdomain ?? null,
                  subdomainStatus: (order.organization as Organization).subdomainStatus ?? null,
                  subdomainVerificationRecords:
                    (order.organization as Organization).subdomainVerificationRecords ?? null,
                },
              } as unknown as AntiCounterfeitOrder)
            : (order as unknown as AntiCounterfeitOrder | null),
        isProcessing: false,
      });
    }, 300);
  }

  @Action(CreateAntiCounterfeitOrder)
  createAntiCounterfeitOrder(
    { patchState }: StateContext<AntiCounterfeitStateModel>,
    _action: CreateAntiCounterfeitOrder,
  ) {
    patchState({ isProcessing: true });

    // Simulate API delay
    setTimeout(() => {
      // For now, just set processing to false and clear the order
      patchState({
        antiCounterfeitOrder: null,
        isProcessing: false,
      });
    }, 500);
  }

  @Action(UpdateAntiCounterfeitOrder)
  updateAntiCounterfeitOrder(
    { patchState }: StateContext<AntiCounterfeitStateModel>,
    _action: UpdateAntiCounterfeitOrder,
  ) {
    patchState({ isProcessing: true });

    // Simulate API delay
    setTimeout(() => {
      // For now, just set processing to false and clear the order
      patchState({
        antiCounterfeitOrder: null,
        isProcessing: false,
      });
    }, 500);
  }

  @Action(DeleteAntiCounterfeitOrder)
  deleteAntiCounterfeitOrder(
    { patchState }: StateContext<AntiCounterfeitStateModel>,
    _action: DeleteAntiCounterfeitOrder,
  ) {
    patchState({ isProcessing: true });

    // Simulate API delay
    setTimeout(() => {
      patchState({ isProcessing: false });
    }, 300);
  }

  @Action(ResetAntiCounterfeitHeaders)
  resetHeaders({ patchState }: StateContext<AntiCounterfeitStateModel>) {
    patchState({ headers: [] });
  }
}
